import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import { useEffect, useState } from "react";
import {
  NFCeModalDestinatarioSchema,
  NFCeModalFinalizarProps,
  NFCeModalPagamentoSchema,
} from "./NFCe.Modal.Finalizar.Dto";
import { FormatarVirgulaPonto, SoNumeros } from "src/hook/Functions";
import {
  DestinatarioNFCeDto,
  MeioPagamentoDto,
  MeioPagamentoNFCeDto,
} from "../NFCe.Dto";

const NFCeModalFinalizaCode = (props: NFCeModalFinalizarProps) => {
  const totalPago = () => {
    const pago = props.dataMeioPagamento.reduce((acc, item) => {
      const valor =
        typeof item.valorPagamento === "string"
          ? Number(FormatarVirgulaPonto(item.valorPagamento))
          : Number(item.valorPagamento);
      return acc + (isNaN(valor) ? 0 : valor);
    }, 0);
    return pago;
  };

  const totalTroco = () => {
    const troco = totalPago() - props.totalNFCe;
    if (troco < 0) {
      return 0;
    }
    return troco;
  };

  const podeFinalizar = () => {
    return totalPago() >= props.totalNFCe;
  };

  const form = useForm<MeioPagamentoNFCeDto>({
    resolver: yupResolver(NFCeModalPagamentoSchema),
  });

  const destinatarioForm = useForm<DestinatarioNFCeDto>({
    resolver: yupResolver(NFCeModalDestinatarioSchema),
  });

  const [exibirValor, setExibirValor] = useState(false);
  const [selecionadoMeioPagamento, setSelecionadoMeioPagamento] =
    useState<MeioPagamentoDto>();

  useEffect(() => {
    if (!exibirValor) return;

    const restante = Math.max(
      0,
      Number((props.totalNFCe - totalPago()).toFixed(2))
    );
    const valorFormatado = restante.toFixed(2).replace(".", ",");
    form.setValue("valorPagamento", valorFormatado as unknown as number);

    const timer = setTimeout(() => {
      form.setValue("valorPagamento", valorFormatado as unknown as number);
      form.setFocus("valorPagamento", { shouldSelect: true });
    }, 100);

    return () => {
      clearTimeout(timer);
    };
  }, [exibirValor]);

  const onSubmitMeioPagamento = async (data: MeioPagamentoNFCeDto) => {
    data.meioPagamento = selecionadoMeioPagamento?.meioPagamento;
    // Crédito (3), Débito (4) e PIX (17): 2 = não integrado com automação.
    data.tipoIntegracao = [3, 4, 17].includes(data.meioPagamento ?? 0) ? 2 : null;
    data.valorPagamento = Number(FormatarVirgulaPonto(data.valorPagamento as unknown as string));
    props.onSelect(data);
    setExibirValor(false);
    setSelecionadoMeioPagamento(undefined);
    form.reset();
  };

  const onSubmitDestinatario = async (
    data: DestinatarioNFCeDto | undefined
  ) => {
    props.onHide();
    if (data && data.documento) {
      data.documento = SoNumeros(data.documento);
      data.indicadorInscricaoEstadual = 9;
    } else {
      data = undefined;
    }
    props.onSubmit(data);
  };

  const handleClickMeioPagamento = (value: MeioPagamentoDto) => () => {
    setSelecionadoMeioPagamento(value);
    const restante = Math.max(
      0,
      Number((props.totalNFCe - totalPago()).toFixed(2))
    );
    form.setValue(
      "valorPagamento",
      restante.toFixed(2).replace(".", ",") as unknown as number
    );
    setExibirValor(true);
  };

  const onHideClick = () => {
    if (exibirValor) {
      form.reset();
      setExibirValor(false);
    } else {
      props.onHide();
    }
  };

  const onReiniciarPagamentos = () => {
    form.reset();
    setExibirValor(false);
    setSelecionadoMeioPagamento(undefined);
    props.onCancel();
  };

  return {
    form,
    onSubmitMeioPagamento,
    exibirValor,
    setExibirValor,
    selecionadoMeioPagamento,
    setSelecionadoMeioPagamento,
    handleClickMeioPagamento,
    totalPago,
    totalTroco,
    onHideClick,
    podeFinalizar,
    onCancelClick: onReiniciarPagamentos,
    onReiniciarPagamentos,
    onSubmitDestinatario,
    destinatarioForm,
  };
};

export default NFCeModalFinalizaCode;
